import { PencilIcon } from '@grupoboticario/flora-react-icons';
import { CardInfo } from '../../sharedStyles';

import { CardInfoTitleSummary, EditButton, CardInfoFields } from '../styles';

interface ICardSummary {
  editStep?: any;
  stateClaim: any;
}

export const Card02 = ({ editStep, stateClaim }: ICardSummary): JSX.Element => {
  return (
    <CardInfo>
      <CardInfoTitleSummary>
        Dados da ocorrência
        {editStep && (
          <EditButton
            size="small"
            has="iconLeft"
            icon={<PencilIcon />}
            onClick={() => editStep(2)}
          >
            Editar
          </EditButton>
        )}
      </CardInfoTitleSummary>
      <CardInfoFields>
        <span className="singleLine">Descrição da Ocorrência:</span>
        <p className="singleLine">
          {stateClaim.step.step2?.occurrenceDescription}
        </p>
        <hr />
        <span className="singleLine">Datas da Ocorrência:</span>
        <p className="singleLine">{stateClaim.step.step2?.occurrenceDate}</p>
        <hr />
        <span className="singleLine">Prejuízo Estimado:</span>
        <p className="singleLine">
          {stateClaim.step.step2?.estimateLoss
            ? stateClaim.step.step2?.estimateLoss
            : 'Valor não inserido'}
        </p>
      </CardInfoFields>
    </CardInfo>
  );
};
